import { Component, Input, OnChanges, output, Output, SimpleChanges, ViewChild, OnDestroy } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';
import {
  ColDef,
  NumberEditorModule,
  NumberFilterModule,
  RowSelectionModule,
  TextEditorModule,
  ValidationModule,
  themeAlpine,
} from 'ag-grid-community';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import { SpActionButton, SpColumn } from '../../../models/client-models/entities/sp-columns';
import { TranslateService } from '@ngx-translate/core';
import { ActionsCellRendererComponent } from '../actions-cell-renderer/actions-cell-renderer';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

ModuleRegistry.registerModules([
  AllCommunityModule,
  ValidationModule,
  TextEditorModule,
  RowSelectionModule,
  NumberFilterModule,
  NumberEditorModule,
]);

@Component({
  selector: 'app-custom-sp-table',
  standalone: false,
  templateUrl: './custom-sp-table.component.html',
  styleUrls: ['./custom-sp-table.component.scss'],
})
export class CustomSpTableComponent<T> implements OnChanges, OnDestroy {
  @ViewChild(AgGridAngular) agGrid?: AgGridAngular;

  @Input() columns: SpColumn<T>[] = [];
  @Input() actions: SpActionButton<T>[] = [];
  @Input() rowData: T[] = [];

  @Input() hoverable = true;

  rowClicked = output<(row: T) => void>();

  constructor(private translateService: TranslateService) {}
  myTheme = themeAlpine.withParams({ accentColor: 'red' });
  public theme = this.myTheme;

  private destroy$ = new Subject<void>();

  ngAfterViewInit() {
    this.translateService.onLangChange.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.updateColumnDefs();
      this.agGrid?.api.refreshHeader();
      this.agGrid?.api.refreshCells();
    });
  }
  columnDefs: ColDef[] = [];

  defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    resizable: true,
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['columns']) {
      this.updateColumnDefs();
    }
  }

  private updateColumnDefs(): void {
    this.columnDefs = this.columns.map((col) => {
      return {
        headerValueGetter: () => this.translateService.instant(col.name),
        valueGetter: (params) => col.propertySelector(params.data),
        cellRenderer: col.cellRenderer ? col.cellRenderer : undefined,
      };
    });

    if (this.actions.length > 0) {
      this.columnDefs.push({
        headerName: this.translateService.instant('PRINT.OFFICE.ORDER.TABLE.ORDER.ACTION'),
        field: 'actions',
        cellRenderer: ActionsCellRendererComponent,
        cellRendererParams: {
          actions: this.actions,
        },
        sortable: false,
        filter: false,
      });
    }
  }

  onRowClicked(event: any) {
    this.rowClicked.emit(event.data);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
